import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import { applyTheme, getStoredTheme } from "./hooks/useTheme";
import { initWebVitals } from "./lib/web-vitals-reporter";
import { initSentry } from "./lib/sentry";

// Init Sentry as early as possible so module-load errors are captured.
initSentry();

// Apply persisted theme as early as possible to avoid a flash of the default palette.
applyTheme(getStoredTheme());

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);

// Boot Web Vitals collection after first paint; reporter no-ops on sandbox hosts.
initWebVitals();
